import React, {useState, useEffect, useRef} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Pagination} from "swiper/modules";
import {Col, Container, Image, Row} from "react-bootstrap";

import "swiper/css";
import "swiper/css/pagination";
import './mixedSlider.css'
import CustomButton from "../customBtn/CustomButton";
import apiRequest from "../../../services/Axios/Configs/configs";
import {toast} from "react-toastify";
import axios from "axios";
import {useData} from "../../../context/DataContext";

const MixedSlider = () => {

    /*axios.get('http://192.168.1.3:8080/api/v1/sliders/')
        .then(response => {
            console.log(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });*/

    /* useEffect(() => {
         apiRequest.get("blog/")
             .then(response => console.log(response.data))
             .catch(error => console.error(error));
     }, []);*/
    const [slides, setSlides] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const slideInterval = useRef(null);
    const {data, fetchData, loading} = useData();



    const nextSlide = () => {
        setCurrentSlide((prev) => (slides.length > 0 ? (prev + 1) % slides.length : 0));
    };

    const startAutoSlide = () => {
        slideInterval.current = setInterval(nextSlide, 4000);
    };

    const stopAutoSlide = () => {
        clearInterval(slideInterval.current);
    };

    /*useEffect(() => {
        apiRequest.get('sliders/').then(response => {
            setSlides(response.data)
        })
            .catch(error => console.error(error));
    }, []);*/


    useEffect(() => {
        if (data.slider.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("slider", "sliders/");
        } else {
            setSlides(data.slider);
        }
    }, [data.slider]);

    useEffect(() => {
        if (slides.length > 0) {
            setCurrentSlide(0);
            startAutoSlide();
        }
        return () => stopAutoSlide();
    }, [slides]); // اینجا وابستگی به slides رو اضافه کردیم


    return (
        <div className={'mixed-slider-wrapper'}>
            <Container>

                <Row style={{display: "flex", flexDirection: "row", height: "400px", position: "relative"}}>
                    {/* ستون سمت راست: متن */}
                    <Col sm={12} md={6}
                         className={'right-col d-flex justify-content-center align-items-start flex-column'}
                         style={{}}
                         onMouseEnter={stopAutoSlide}
                         onMouseLeave={startAutoSlide}
                    >
                        {slides.map((slide, index) => (
                            <div
                                key={slide.id}
                                style={{
                                    // position: "absolute",
                                    top: 0,
                                    left: 0,
                                    display: currentSlide === index ? "block" : "none",
                                    animation: "fadeText 1s",
                                    transition: "opacity 0.5s",
                                }}
                            >
                                <h2>{slide.title}
                                </h2>
                                <p className={'text-end'}>{slide.description}
                                </p>
                                <div className={'d-flex gap-3'}>
                                    <CustomButton icon={<i className={`fa-regular fa-${slide.button1_icon}`}></i>}
                                                  bgColor={'#D3EDE6'} height={'3rem'}
                                                  width={'12.5rem'} href={slide.button1_link} text={slide.button1_title}
                                                  isLink
                                    />
                                    <CustomButton icon={<i className={`fa-regular fa-${slide.button2_icon}`}></i>}
                                                  bgColor={'#1D2E3D'}
                                                  color={'#fff'} width={'12.5rem'} height={'3rem'}
                                                  href={slide.button2_link} text={slide.button2_title}
                                                  isLink
                                    />
                                </div>
                            </div>
                        ))}
                    </Col>

                    {/* ستون سمت چپ: عکس */}
                    <Col sm={12} md={6}
                         className={'d-flex justify-content-center align-items-start flex-column'}
                    >
                        {slides.map((slide, index) => (
                            <img
                                key={slide.id}
                                src={slide.image}
                                alt={`Slide ${slide.id}`}
                                style={{
                                    position: "absolute",
                                    // top: 0,
                                    // left: '9rem',
                                    // maxWidth: "600px",
                                    // width: "25vw",
                                    // height: "90%",
                                    objectFit: "contain",
                                    opacity: currentSlide === index ? 1 : 0,
                                    transform: `scale(${currentSlide === index ? 1 : 0})`,
                                    transition: "opacity 0.5s linear, transform 0.5s 0.5s linear",
                                    overflow: 'visible',
                                }}
                            />
                        ))}
                    </Col>
                </Row>
                {/* صفحه‌بندی */}
                <div className="pagination" style={{textAlign: "center", marginTop: "10px"}}>
                    {slides.map((_, index) => (
                        <span
                            className={`pagination-dot ${
                                index === currentSlide ? "active" : ""
                            }`}
                            key={index}
                            onClick={() => setCurrentSlide(index)}
                            style={{
                                // backgroundColor: currentSlide === index ? "#333" : "#ccc"
                            }}
                        ></span>
                    ))}
                </div>
            </Container>
        </div>

    );
};

export default MixedSlider;